<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('listeProduitFace.breadcrumb.listeSuiviAffectations') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px columns">
      <div class="level-left column is-6">
        <div class="columns">
          <form @submit.prevent="recherche()"
                class="column is-6 pdr-0">
            <b-input is-medium :placeholder="$t('listeProduitFace.actions.search')"
                     type="search"
                     v-model="criteresRecherche.auto"
                     icon="magnify">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('listeProduitFace.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
                  class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns column">
        <parametrage-table
          v-if="startArrayRendering"
          :reference-table="referenceTable">
        </parametrage-table>
      </div>
    </div>
    <v-server-table url="" v-if="startArrayRendering"
                    :columns="columns"
                    :options="options"
                    @loaded="finLoading"
                    @loading="debutLoading"
                    :ref="referenceTable">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <template slot="reference" slot-scope="props">
        <router-link-blank
          :to="{ name: 'c.bodac.catalogue-face',
        params: { id: props.row.id, isFromListeProduitFace: true }}"
          :message="props.row.reference"/>
      </template>
      <template slot="adresse" slot-scope="props">
        {{ adressFullStringGetter(getAdresseObject(props.row), true) }}
      </template>
      <template slot="codePostal" slot-scope="props">
        {{ props.row.codePostal }}
      </template>
      <template slot="ville" slot-scope="props">
        {{ props.row.ville }}
      </template>
      <template slot="departement" slot-scope="props">
        {{ props.row.departement }}
      </template>
      <template slot="etat" slot-scope="props">
        {{ getEtatFace(props.row) }}
      </template>
      <template slot="format" slot-scope="props">
        {{ props.row.format }}
      </template>
      <template slot="materielType" slot-scope="props">
        {{ props.row.materielType }}
      </template>
      <template slot="disposition" slot-scope="props">
        {{props.row.disposition }}
      </template>
      <template slot="support" slot-scope="props">
        {{props.row.support }}
      </template>
      <template slot="affectation" slot-scope="props">
        <info-affectations :row="props.row"
            :affectations="props.row.affectations"
            :faceMotifNonComId="props.row.faceMotifNonComId"
            :isFromLigneFace="false">
        </info-affectations>
      </template>
      <template slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.agenceId) }}
      </template>
      <template slot="societe" slot-scope="props">
        {{ getLibelleSociete(props.row.societeId) }}
      </template>
      <template slot="actif" slot-scope="props">
        {{ getLibelleActif(props.row.actif) }}
      </template>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-produit-face
            :isSuiviAffectations="true"
            ref="filtreListeProduitFace"
            @toggleFiltre="setShowFiltre"
            @recherche="makeRechercheFilter()"
        />
      </div>
    </transition>
  </div>
</template>

<script>

import breadcrumb from '@/components/general/breadcrumb';
import parametrageTable from '@/components/general/parametrageTable';
import infoAffectations from '@/components/general/infoAffectations';
import { REFERENCE_TABLE_SUIVI_AFFECTATION_PRODUIT_FACE } from '@/configuration/general/referenceTableConf';
import { createNamespacedHelpers } from 'vuex';
import subscribeMutation from '@/services/store/subscribeMutation';
import messageErreur from '@/services/general/messageErreur';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import formatIsoDate from '@/services/general/formatIsoDate';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import traductionLibelleEtat from '@/services/devisCommandes/traductionLibelleEtat';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import { columnsSplice } from '@/services/general/columns';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import filtreListeProduitFace from '@/components/catalogue/filtre/filtreListeProduitFace';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import TableItemsInView from '@/components/general/TableItemsInView';
import RouterLinkBlank from '@/components/general/routerLinkBlank';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const ProduitFaceSuiviAffectations = createNamespacedHelpers('produitFaceSuiviAffectations');

export default {
  name: 'c_suivi_affectation',
  data() {
    return {
      showFiltre: false,
      startArrayRendering: false,
      referenceTable: REFERENCE_TABLE_SUIVI_AFFECTATION_PRODUIT_FACE,
      listeEtats: traductionLibelleEtat(this.$i18n, ETAT_DISPOSITIF_PUBLICITAIRE),
      unsubscribeValue: null,
    };
  },
  components: {
    RouterLinkBlank,
    TableItemsInView,
    parametrageTable,
    breadcrumb,
    filtreListeProduitFace,
    infoAffectations,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActive: 'societeActive',
      societeActiveId: 'societeActiveId',
      agenceActive: 'agenceActive',
      agencesInformations: 'agencesInformations',
      societesInformations: 'societesInformations',
      lockMenu: 'lockMenu',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...ProduitFaceSuiviAffectations.mapGetters({
      criteresRecherche: 'criteresRecherche',
      total: 'totalProduits',
      produitsFace: 'produits',
      lastPayload: 'lastPayload',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeProduitFace.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeProduitFace.breadcrumb.listeSuiviAffectations'), route: '', isActive: true },
      ];
    },
    columns() {
      const columns = [
        'reference', 'adresse', 'codePostal', 'ville', 'departement', 'etat', 'format',
        'materielType', 'disposition', 'support', 'affectation', 'agence', 'societe', 'actif',
      ];
      if (this.societesInformations.length === 1 || this.filtrerProduitParSociete
        || this.filtrerProduitParAgence) {
        columnsSplice(columns, 'societe');
      }
      if (this.user.agences.length <= 1) {
        columnsSplice(columns, 'agence');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          reference: this.$i18n.t('listeProduitFace.tabs.reference'),
          societe: this.$i18n.t('listeProduitFace.tabs.societe'),
          ville: this.$i18n.t('listeProduitFace.tabs.ville'),
          codePostal: this.$i18n.t('listeProduitFace.tabs.codePostal'),
          departement: this.$i18n.t('listeProduitFace.tabs.departement'),
          adresse: this.$i18n.t('listeProduitFace.tabs.adresse'),
          format: this.$i18n.t('listeProduitFace.tabs.format'),
          materielType: this.$i18n.t('listeProduitFace.tabs.materiel'),
          support: this.$i18n.t('listeProduitFace.tabs.support'),
          affectation: this.$i18n.t('listeProduitFace.tabs.affectation'),
          agence: this.$i18n.t('listeProduitFace.tabs.agence'),
          actif: this.$i18n.t('listeProduitFace.tabs.actif'),
          disposition: this.$i18n.t('listeProduitFace.tabs.disposition'),
          etat: this.$i18n.t('listeProduitFace.tabs.etat'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        sortable: ['reference', 'ville', 'codePostal', 'departement', 'materielType', 'support', 'actif'],
        requestFunction: ((data) => {
          if (this.filtrerProduitParAgence && this.criteresRecherche.agencesId.length === 0) {
            this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
          }
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          if (this.user.agences.length === 1) {
            data.query.agencesId = [this.user.agences[0].agenceId];
          }
          data.query.societeId = data.query.societeId ?? this.societeActiveId;
          data.query.dateConsultation = formatIsoDate(data.query.dateConsultation);
          return this.loadProduits(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.produitsFace,
            count: this.total,
          };
        }),
      };
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
    nombreCritere() {
      const banCritere = ['auto', 'actif', 'nonCommercialisable', 'proposableReseau', 'proposableLc', 'eclaire', 'avecLiaisonsTarif', 'controleDisponibilite'];
      if (this.societeActive.agences.length === 1) banCritere.push('agencesId');
      if (this.societesInformations.length === 1) banCritere.push('societeId');
      let nbCritere = calculNombreCritere(this.criteresRecherche, banCritere);
      if (this.criteresRecherche.actif !== null) nbCritere += 1;
      if (this.criteresRecherche.nonCommercialisable !== null) nbCritere += 1;
      nbCritere += this.criteresRecherche.proposableReseau !== null ? 1 : 0;
      nbCritere += this.criteresRecherche.proposableLc !== null ? 1 : 0;
      nbCritere += this.criteresRecherche.eclaire !== null ? 1 : 0;
      nbCritere += this.criteresRecherche.avecLiaisonsTarif !== null ? 1 : 0;
      nbCritere += this.criteresRecherche.controleDisponibilite !== null ? 1 : 0;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
  },
  methods: {
    adressFullStringGetter,
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Societe.mapActions({
      loadSocietes: 'loadSocietes',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...ProduitFaceSuiviAffectations.mapActions({
      loadProduits: 'loadProduits',
    }),
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    getAgenceLibelle(agenceId) {
      const agenceFind = this.agencesInformations.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agenceFind) return agenceFind.libelleAgence;
      return '';
    },
    getLibelleSociete(societeId) {
      const societe = this.societesInformations.find((societe) => {
        return societe.id === societeId;
      });
      return societe ? societe.libelle : null;
    },
    getLibelleActif(actif) {
      if (actif) return this.$t('general.non');
      return this.$t('general.oui');
    },
    getEtatFace(produit) {
      const etatFind = this.listeEtats.find((etat) => {
        return etat.value === produit.etat;
      });
      return etatFind ? etatFind.libellei18n : null;
    },
    getAdresseObject(row) {
      return {
        adresse1: row.adresse1,
        adresse2: row.adresse2,
        adresse3: row.adresse3,
        codePostal: row.codePostal,
        ville: row.ville,
      };
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    updateAgenceAndRecherche() {
      if (this.filtrerProduitParAgence) {
        this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      this.recherche();
    },
    async reinitialiser() {
      await this.$refs.filtreListeProduitFace.initializeFiltre();
      this.$refs.filtreListeProduitFace.viderCritere();
      this.$refs.filtreListeProduitFace.appliquerCritere();
      this.showFiltre = false;
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeProduitFace.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
  },
  beforeDestroy() {
    if (this.filtrerProduitParSociete || this.filtrerProduitParAgence) {
      this.unsubscribeValue();
    }
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadSocietes({});
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
      ]);
      if (this.filtrerProduitParSociete || this.filtrerProduitParAgence) {
        this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      }
      this.criteresRecherche.societeId = this.societeActiveId;
      if (this.user.agences.length > 1) {
        this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      this.setInformationPage(this.$t('pageGescom.produitFace.listeSuiviAffectations'));
      this.startArrayRendering = true;
    } catch (e) {
      messageErreur(this.$i18n);
      throw (e);
    } finally {
      loadingComponent.close();
    }
  },
};
</script>

<style scoped>

</style>
